import React, { Component } from 'react';

// MetisMenu
import MetisMenu from 'metismenujs';
import { Link } from 'react-router-dom';

// i18n
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
    changeLayout,
    changeLayoutWidth,
    changeSidebarTheme,
    changeSidebarType,
    changePreloader,
} from '../../store/actions';
import withRouter from '../Common/withRouter';

class SidebarContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pathName: this.props.router.location.pathname,
        };
        this.metisMenuInstance = null;
    }

    componentDidMount() {
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        const { pathname } = this.props.router.location;

        if (prevProps.router.location.pathname !== pathname) {
            this.setState({ pathName: pathname }, () => {
                this.initMenu();
            });
        }
    }

    initMenu() {
        // Destroy previous MetisMenu instance to avoid duplication
        if (this.metisMenuInstance) {
            this.metisMenuInstance.dispose();
        }

        // Initialize MetisMenu
        this.metisMenuInstance = new MetisMenu('#side-menu');

        // Set active menu item
        this.updateActiveLink();
    }

    updateActiveLink() {
        const { pathName } = this.state;

        // Remove active classes from all menu items
        const items = document.querySelectorAll('#side-menu a');
        items.forEach((item) => {
            item.classList.remove('active');
            const parent = item.parentElement;
            if (parent) {
                parent.classList.remove('mm-active', 'mm-show');
            }
        });

        // Find the matching menu item
        let matchingMenuItem = null;
        items.forEach((item) => {
            if (pathName === item.pathname) {
                matchingMenuItem = item;
            }
        });

        // Activate the matching menu item and its parent dropdowns
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown(item) {
        item.classList.add('active');
        let parent = item.parentElement;

        while (parent && parent.id !== 'side-menu') {
            parent.classList.add('mm-active');
            if (parent.tagName === 'UL') {
                parent.classList.add('mm-show');
            }
            parent = parent.parentElement;
        }
    }

    render() {
        return (
            <React.Fragment>
                <div id='sidebar-menu'>
                    <ul className='metismenu list-unstyled' id='side-menu'>
                        <li className='menu-title'>{this.props.t('Menu')}</li>

                        <li>
                            <Link to='/dashboard' className='waves-effect'>
                                <i className='ri-dashboard-line'></i>
                                <span className='ms-1'>
                                    {this.props.t('Dashboard')}
                                </span>
                            </Link>
                        </li>
                        <li>
                            <Link to='/#' className='has-arrow waves-effect'>
                                <i className='fas fa-user-tag'></i>
                                <span className='ms-1'>
                                    {this.props.t('Vendor')}
                                </span>
                            </Link>
                            <ul className='sub-menu'>
                                <li>
                                    <Link to='/vendor-user-list'>
                                        {this.props.t('Vendor User')}
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link
                                to='/po-headers-list'
                                className='waves-effect'
                            >
                                <i className='fas fa-info-circle'></i>
                                <span className='ms-1'>
                                    {this.props.t('PO Information')}
                                </span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = (state) => {
    return { ...state.Layout };
};

export default withRouter(
    connect(mapStatetoProps, {
        changeLayout,
        changeSidebarTheme,
        changeSidebarType,
        changeLayoutWidth,
        changePreloader,
    })(withTranslation()(SidebarContent))
);
